const PrintTemplateItemType = {
  IMAGE: 1,
  TEXT: 2,
  QR_CODE: 3
}
export default PrintTemplateItemType
